'use client';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { fetchApi } from '@/lib/api/client';
import { useTranslation } from '@/lib/i18n';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
const accessSchema = z.object({ disabledModules: z.array(z.object({ module: z.string(), reason: z.string() })) });
/** Read only after a Vishing chat surface mounts; never triggers a provider. */
export function VishingChatNotice() {
  const { t } = useTranslation();
  const query = useQuery({ queryKey: ['ai-chat', 'module-access', 'vishing'], staleTime: 0, retry: false, queryFn: async ({ signal }) => accessSchema.parse(await fetchApi<unknown>('/ai-chat/tools?module=vishing&implementedOnly=true', { signal })) });
  if (!query.data?.disabledModules.some((entry) => entry.module === 'vishing' && entry.reason === 'voice_residency')) return null;
  return <Alert data-testid="vishing-chat-residency"><AlertTitle>{t('vishing.ai.residencyTitle')}</AlertTitle><AlertDescription>{t('vishing.ai.residencyUnavailable')}</AlertDescription></Alert>;
}
